import { render } from "./Type.vue?vue&type=template&id=7ab0edf6&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"

import "./Type.vue?vue&type=style&index=0&id=7ab0edf6&lang=css"
import "./Type.vue?vue&type=style&index=1&id=7ab0edf6&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab0edf6"]])

export default __exports__